/**
 * ProfileSkeleton — loading placeholder for the member profile route.
 *
 * Rendered by a Suspense boundary while the profile data loads from the port.
 * Must not produce horizontal overflow at 375 px viewports (FR-012).
 * No raw colour literals (FR-013) — token classes only.
 *
 * Owned by feature 018-omat-tiedot.
 * Task: T012
 */

import type { JSX } from 'react';

export function ProfileSkeleton(): JSX.Element {
  return (
    <div className="flex flex-col gap-4">
      {/* Avatar + name placeholder */}
      <div className="flex items-center gap-3">
        <div className="h-12 w-12 rounded-full bg-muted animate-pulse" />
        <div className="flex-1">
          <div className="mb-2 h-5 w-32 bg-muted rounded animate-pulse" />
          <div className="h-4 w-24 bg-muted/60 rounded animate-pulse" />
        </div>
      </div>

      {/* Member number row placeholder */}
      <div className="h-5 w-40 bg-muted rounded animate-pulse" />

      {/* Tier + date placeholder */}
      <div className="flex flex-col gap-2">
        <div className="h-5 w-32 bg-muted rounded animate-pulse" />
        <div className="h-5 w-48 bg-muted/60 rounded animate-pulse" />
      </div>

      {/* Contact section placeholder */}
      <div className="flex flex-col gap-3 border-t border-border pt-4">
        <div className="h-5 w-20 bg-muted rounded animate-pulse" />
        <div className="h-4 w-40 bg-muted/60 rounded animate-pulse" />
        <div className="h-4 w-36 bg-muted/60 rounded animate-pulse" />
        <div className="h-4 w-44 bg-muted/60 rounded animate-pulse" />
      </div>
    </div>
  );
}
